import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { OutreachContactsContext } from "contexts/OutreachContacts";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import ThreadPreview from ".";

const ScheduledMobileThreadPreview = () => {
  const navigate = useNavigate();
  const { currentContact } = useContext(OutreachContactsContext);
  const closeFullScreen = () => {
    navigate(`/${routes.inboxScheduled}`);
  };

  return (
    <Dialog open={true} fullScreen>
      <DialogTitle sx={{ backgroundColor: "secondary.light", py: 1 }}>
        <Grid alignItems="center" container justifyContent="space-between">
          {currentContact?.brand?.name}
          <IconButton
            onClick={closeFullScreen}
            sx={{ fontSize: 12, color: "black" }}
          >
            <Box component="i" className="fa-regular fa-xmark" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ px: 0 }}>
        <ThreadPreview />
      </DialogContent>
    </Dialog>
  );
};

export default ScheduledMobileThreadPreview;
